import axios from 'axios';

const PREFIJO="/api/App/";

export default {
    obtenerAplicacion(){
        const dto={dt1:process.env.VUE_APP_API_KEY};
        return axios.post(`${PREFIJO}VmApp`,dto);
    },
};
